import Vue from 'vue'
import MicrosoftAdsTracking from 'chimera/all/plugins/tracking/microsoft'

export default ({ env, store }) => {
  Vue.use(MicrosoftAdsTracking, {
    tagId: env.msUetTag,
    store,
  })
}
